import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

export interface ScheduleLockPayload {
  fromDate: string;
  toDate: string;
  locked: boolean;
}

@Injectable({ providedIn: 'root' })
export class ScheduleLockApiService {
  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService
  ) {}

  private get url(): string {
    return `${this.environmentService.getCurrentApiUrl()}/schedule-locks`;
  }

  updateScheduleLock(body: ScheduleLockPayload): Observable<any> {
    return this.httpClient.post<any>(this.url, body);
  }

  // Fetch locks using backend contract: POST /schedule-locks/get with PaginationRequest in query and SearchOptionsDTO in body
  getScheduleLocks(fromDate: string, toDate: string, locked: boolean = true): Observable<any> {
    const params: any = { limit: 200, offset: 0 }; // week range is small; 200 is safe
    const body: any = {
      andQ: { from: fromDate, to: toDate, locked },
      orQ: []
    };
    return this.httpClient.post<any>(`${this.url}/get`, body, { params });
  }

}

